export class VoleiProtocol {
    id: number;
    name:string;
    observations:string;
    timeBefore: number;
    refereeType: number = 1;
}